import { create } from 'zustand'

interface RegisterDrawerState {
  open: boolean
  toggleDrawer: (state?: boolean) => void
}

export const useRegisterStore = create<RegisterDrawerState>((set) => ({
  open: false,
  toggleDrawer: (state) => set((prev) => ({ open: state ?? !prev.open })),
}))
